var has_item_in_cart = true;

(function($){


  $.get('/cart.js', function(data){

    if(data.item_count === 0){

      has_item_in_cart = false;

      $('.affiliate_checkout').addClass('disable');

    }

  }, "json");

  $(document).on('submit', 'form[action="/cart/add"]', function(e){

    e.preventDefault();

    var th = $(this);

    if(th.data('ajaxRunning')){return;}

    th.data('ajaxRunning', true);

    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: th.serialize(),
      dataType: 'json',
      success: success,
      error: error,
      complete: complete
    })

    function success(){
      $.get('/cart.js', function(data){

        $("#CartCount").html(data.item_count);

      }, "json");

      has_item_in_cart = true;

      $('.affiliate_checkout').removeClass('disable');

      th.find(".success-add-msg").show().html("Added successfully");

      ajaxCart.load();
      timber.RightDrawer.open();
    }

    function error(xhr,status,error){

      //console.log(xhr.responseText );

      var err = eval("(" + xhr.responseText + ")");
      alert(err.description);

      //alert(data.description);
    }

    function complete(data){
      th.data('ajaxRunning', false);
    }

  })

  $(document).on('click', "#pager-lg .slick-dots li", function() {

    var width = $(window).width();

    if(width <= 768){

      $('html, body').animate({

        scrollTop: $(".ingredients-mobile").offset().top

      }, 1000);

    }else{
      $('html, body').animate({

        scrollTop: $(".ingredients-lg").offset().top

      }, 1000);

    }


  });


  $(".option-box").hover(function(){

    $(".hover_text").hide();

    $("#" + $(this).data("productmainid")).show();

  }, function(){

    $(".hover_text").hide();

    var id = $(".option-box.selected").data("productmainid");

    $("#" + id).show();

  });

  if($(window).width() < 1024){

    $(".option-box").click(function(){

      $(".hover_text").hide();

      var id = $(this).data("productmainid");

      $("#" + id).show();

    });


    // 

    $(".site-nav .site-nav--has-dropdown > a").attr("href", "javascript:void(0)");


  }



})(jQuery)

function check_cart(param, event){

  if(!has_item_in_cart){

    event.preventDefault();

  }

}


/*---------------------------Site Wide Header----------------------------------------------------*/

// $('.product-details-right').owlCarousel({
//   loop: true,
//   items: 1,
//   autoplay: true,
//   autoplayTimeout: 3000,
//   margin: 5,
//   nav: true,
//   autoplayHoverPause:true
// });


$(document).ready(function () {
  if($(window).width() > 959) {
    $('.announcement_bar .menu-info-icon').mouseover(function(){
      $('.announcement_text_pop').addClass('show');
    });
    $('.announcement_bar .menu-info-icon').mouseout(function(){
      $('.announcement_text_pop').removeClass('show');
    });

    $('.custom_header .menu-item.login').mouseover(function(){
      $('.custom_header .menu-item.login .menu-acc-dropdown').addClass('show');
    });
    $('.custom_header .menu-item.login').mouseout(function(){
      $('.custom_header .menu-item.login .menu-acc-dropdown').removeClass('show');
    });

    $('.product-wrap .free_ship .subs_info_ico').mouseover(function() {
      $('.product-wrap .free_ship .subs_info').addClass('show');
    });
    $('.product-wrap .free_ship .subs_info_ico').mouseout(function() {
      $('.product-wrap .free_ship .subs_info').removeClass('show');
    });
  }

  if($(window).width() < 960) {
    $('.announcement_bar .menu-info-icon').click(function(e) {
      e.stopPropagation();
      $('.announcement_text_pop').toggleClass('show');
    });
    $(document).click(function () {
      var $el = $(".announcement_text_pop");
      if ($el.hasClass('show')) {
        $el.removeClass('show');
      }
    });

    $('.custom_header .menu-item.login').click(function(e) {
      e.stopPropagation();
      $('.custom_header .menu-item.login .menu-acc-dropdown').toggleClass('show');
    });
    $(document).click(function () { 
      var $el = $(".custom_header .menu-item.login .menu-acc-dropdown");
      if ($el.hasClass('show')) {
        $el.removeClass('show');
      }
    });

    $('.product-wrap .free_ship .subs_info_ico').click(function(e) {
      e.stopPropagation();
      $('.product-wrap .free_ship .subs_info').toggleClass('show');
    });
    $(document).click(function () {
      var $el = $(".product-wrap .free_ship .subs_info");
      if ($el.hasClass('show')) {
        $el.removeClass('show');
      }
    });
  }
});

$(document).ready(function() {
  var window_width = $(window).width();
  if (window_width > 1023 && window_width < 1201){
    $('.all-product-menu > a').removeAttr('href');
    $('.all-product-menu .tilte_menu > a:not(.all-formula)').removeAttr('href');

    $('.site-nav--has-dropdown > a').click(function(){
      if($(this).parent().hasClass('open_nav')){
        $(this).parent().removeClass('open_nav');
        $(this).parent().find('.site-nav__dropdown').removeClass('opened_menu');
      }else{
        $(this).parent().addClass('open_nav');
        $(this).parent().find('.site-nav__dropdown').addClass('opened_menu');
      }
      $(this).parent().siblings().removeClass('open_nav');
      $(this).parent().siblings().find('.site-nav__dropdown').removeClass('opened_menu');

      if($('.site-nav--has-dropdown').hasClass('open_nav')){
        $('body').addClass('bodyoverlay');
      }
      else{
        $('body').removeClass('bodyoverlay');
      }
    });
  }
  if (window_width > 1200) {
    $('.site-nav--has-dropdown').mouseover(function(){
      $('body').addClass('bodyoverlay');
    });
    $('.site-nav--has-dropdown').mouseout(function(){
      $('body').removeClass('bodyoverlay');
    });
  }
}); 

$(window).scroll(function() {
  var scroll = $(window).scrollTop();
  if (scroll >= 100) {
    $("body").addClass("sticky_head");
    $(".custom_header").addClass("sticky_header_nav");
  }
  else{
    $("body").removeClass("sticky_head");
    $(".custom_header").removeClass("sticky_header_nav");
  }
});

$('.star_rated_custom_reviews').click(function(){
  var pro_hand = $(this).find('.product_url').text(); 
  if(window.location.href.indexOf(pro_hand) > -1) {
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: $("#product-reviewss").offset().top - 200
      }, 1000);
    },100);
  }else{
    location.replace("/products/"+ pro_hand + "#product-reviewss" );
  }
});


$('.custom_header .tilte_menu').mouseover(function() {
  if("$('.custom_header .submenu_1.hover_submenu li:first-child .product-details').hasClass('first')") {
    $('.custom_header .submenu_1.hover_submenu li:first-child .product-details').removeClass('first');
    $('.custom_header .products_details_wrap').removeClass('first_hover');
  }
  if("$('.custom_header .submenu_2.hover_submenu li:first-child .product-details').hasClass('first')") {
    $('.custom_header .submenu_2.hover_submenu li:first-child .product-details').removeClass('first');
  }
  if("$('.custom_header .submenu_3.hover_submenu li:first-child .product-details').hasClass('first')") {
    $('.custom_header .submenu_3.hover_submenu li:first-child .product-details').removeClass('first');
  }
});
$('.custom_header .hover_submenu').mouseout(function() {
  $('.custom_header .tilte_menu:first-child .product-details').addClass('first');
  $('.custom_header .products_details_wrap').addClass('first_hover');
});


/*----------------------------Product page redesign---------------------------------------------------*/


$('#ProductThumbs.product-single__thumbnails').owlCarousel({
  dots:false,
  items:4,
  nav:true,
  loop: false,
  navText: ["<i class='icon-arrow-prev prev-arrow slick-arrow'></i>", "<i class='icon-arrow-next next-arrow slick-arrow'></i>"],
  responsive: {
    0: {
      items: 1     
    },
    960: {
      items: 3
    },
    1200: {
      items: 4
    }
  }
});

$('.pro_mob_slider .product-single__thumbnails').owlCarousel({
  dots:false,
  items:4,
  nav:true,
  loop: false,
  navText: ["<i class='icon-arrow-prev prev-arrow slick-arrow'></i>", "<i class='icon-arrow-next next-arrow slick-arrow'></i>"],
  responsive: {
    0: {
      items: 1,
      dots: true,
      nav: true
    },
    960: {
      items: 3,
      dots: true,
      nav: true
    },
    1200: {
      items: 4,
      dots: true,
      nav: true
    }
  }
});

$('.icon_change').click(function(){
  $(this).toggleClass('less');
  $('.second-hide').slideToggle();
});

// if($( window ).width() < 961){
//   $('.product-wrap .product-tab-section.product-page .tab-content').remove();
// }

// $('.tab-li').click(function(){
//   var tab_name = $(this).attr('data-href');

//   if ($(window).width() > 960){
//     $(this).addClass('active');
//     $(this).parent().siblings().find('.tab-li').removeClass('active');
//     $('.product-wrap .product-tab-section .tab-content .tabing-content').each(function(){
//       var tab_cont_name = $(this).attr('data-cont');
//       if(tab_cont_name == tab_name){
//         $(this).addClass('active');
//         $(this).siblings().removeClass('active');
//       }
//     });
//   }
//   else{
//     $(this).toggleClass('active');
//     $(this).parent().closest('li').next('.tabing-content').toggleClass('active');
//   }
// });

$('.tab-li').click(function(){
  var tab_name = $(this).attr('data-href');

  if ($(window).width() > 960){
    $(this).addClass('active');
    $(this).parent().siblings().find('.tab-li').removeClass('active');
    $('.product-wrap .product-tab-section .tabing-content').each(function(){
      var tab_cont_name = $(this).attr('data-cont');
      if(tab_cont_name == tab_name){
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
      }
    });
  }
  else{
    $(this).toggleClass('active');
    $(this).parent().closest('li').next('.tabing-content').toggleClass('active');
  }
});

$('.scoll-dwn').click(function(){
  var data_attr = $(this).attr('data-href');

  if(data_attr == 'product-reviewss'){
    if(!$('#' +data_attr).hasClass('active')){
      $('.review_tabs li:first-child').trigger('click');
    }
  }
  else if(data_attr == 'product-questions'){
    if(!$('#' +data_attr).hasClass('active')){
      $('.review_tabs li:nth-child(2)').trigger('click');
    }
  }
  else if(data_attr == 'herbs_section'){
    if(!$('.tab-li.formula_herbs').hasClass('active')){  
      $('.tab-li.formula_herbs').trigger('click');
    }
  }
  else if(data_attr == 'formulaherbs'){
    if(!$('.tab-li.formula_herbs').hasClass('active')){  
      $('.tab-li.formula_herbs').trigger('click');
    }
  }
  else if(data_attr == 'supplements-facts'){
    if(!$('.tab-li.supplements-facts').hasClass('active')){  
      $('.tab-li.supplements-facts').trigger('click');
    }
  }
  else if(data_attr == 'when_how'){
    if(!$('.tab-li.when_how').hasClass('active')){  
      $('.tab-li.when_how').trigger('click');
    }
  }

  setTimeout(function(){
    $('html, body').animate({
      scrollTop: $("#"+ data_attr).offset().top - 200
    }, 1000);
  },100);
});

$('.audio-scoll-dwn').click(function(){
  var data_attr = $(this).attr('data-href');
  setTimeout(function(){
    $('html, body').animate({
      scrollTop: $("#"+ data_attr).offset().top - 100
    }, 1000);
  },100);
});

$('.how_tab').click(function(){
  if(!$('.tab-li.when_how').hasClass('active')){
    $('.tab-li.when_how').trigger('click');
  }
  setTimeout(function(){
    $('html, body').animate({
      scrollTop: $("#how_id").offset().top - 350
    }, 1000);
  },100);
});

$('.change_tab').click(function(){
  $('.tab-li.formula_herbs').trigger('click');
  setTimeout(function(){
    $('html, body').animate({
      scrollTop: $("#herbs_section").offset().top - 350
    }, 1000);
  },100);
});


// $('.stamped-product-reviews-badge').click(function(){
//   $('.second-hide li:first-child a').trigger('click');
// });

$('.product-information .stamped-product-reviews-badge').click(function(){
  $('.second-hide li:first-child a').trigger('click');
  $('html, body').animate({
    scrollTop: $("#stamped-main-widget").offset().top - 200
  }, 1000);
});

// Product review tabs
$('.review_tabs li').click(function(){
  var id = $(this).attr('data-tab');
  $('.review_tabs li').removeClass('active');
  $(this).addClass('active'); 
  $(".review_qa_section .scene").each(function(){
    $(this).removeClass('active');
    if($(this).attr('id') == id) {
      $(this).addClass('active');
    }
  });
});

$(document).ready(function(){
  $('.herbs-with-images.owl-carousel').owlCarousel({
    dots:true,
    //items:1,
    nav:true,
    //loop: true,
    autoplay:true,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
    navText: ["<i class='icon-arrow-prev prev-arrow slick-arrow'></i>", "<i class='icon-arrow-next next-arrow slick-arrow'></i>"],
    responsive: {
      0: {
        items: 1,
        nav: true
      },
      667: {
        items: 2
      },
      960: {
        items: 3
      },
      1200: {
        items: 4
      }
    }
  });
});

if (jQuery(window).width() < 960) {

  $('.pro_related-links').owlCarousel({
    dots: true,
    items: 1,
    nav: false,
    loop: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true
  });

  $('.pro_rel-articles').owlCarousel({
    dots: true,
    items: 1,
    nav: false,
    loop: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true
  });

}

/*--------------------------Custom JS for Updated subscription design--------------------------*/

$(document).ready(function() {
  $('.details').each(function() {
    var comma_delete = $(this).text().trim();
    var newString = comma_delete.slice(-1);
    if(newString == ','){
      $(this).text(comma_delete.replace(/,\s*$/, ""));
    }
    var detail_text = $(this).text().toLowerCase();
    if(detail_text.indexOf("day") > -1){
      var mod = $(this).html();
      mod = mod.replace("Day", "Day<br/>");
      $(this).html(mod);
    }
  });
  //for update the price on ui after page load
  var pro_pri = $('.option-box.selected').find('.product-price.money').text();
  var pro_strike = $('.option-box.selected').find('.strike_price').text();
  if($('.option-box.selected').find('.hidden_you_save')[0]){
    var save_html = $('.option-box.selected').find('.hidden_you_save').html();
  }else{
    var save_html = "";
  }
  if(pro_strike != ""){
    $('.var-strike-price').text(pro_strike);
  }
  else{
    $('.var-strike-price').text("");
  }
  if(save_html != ""){
    $('.pro_save_price_per').html(save_html);
  }
  else{
    $('.pro_save_price_per').html("");
  }
  $('.price_from_inner').text(pro_pri);
  // for show free shipping text under add to cart after page load
  //   var pro_supp = $('.option-box.selected').find('.supply-time').text().toLowerCase();  
  //   if(pro_supp.indexOf("free") > -1){
  //     $('.free_ship').removeClass("hide");
  //   }
  //   else{
  //     $('.free_ship').addClass("hide");
  //   }
  // for show subscibe in add to cart after page load
  var add_cart_btn = $('.option-box.selected').find('.option-title h4').text().toLowerCase();
  if(add_cart_btn.indexOf("subscribe") > -1){
    $('#AddToCartText').text("Add to Cart & Subscribe");
  }
  else{
    $('#AddToCartText').text("Add to Cart");
  }
  // for show save percentage after page load
  var save_percentage = $('.option-box.selected').find('.supply-time').text().toLowerCase();
  if(save_percentage.indexOf("save") > -1){
    var final_save_text = save_percentage.split('+')[0];
    if(final_save_text.indexOf("day") > -1){
      var final_update_save_text = final_save_text.split('day')[1];
      $('.save_price').text(final_update_save_text);
      $('.save_price').addClass('lable_enable');  
    }else{
      $('.save_price').text(final_save_text);
      $('.save_price').addClass('lable_enable');
    }
  }
  else{
    $('.save_price').text(" "); 
    $('.save_price').removeClass('lable_enable');
  }
  var boldAppPlanID = $("input[data-bsub-selling-plan-id-input]").val();
  $(".bsub-widget").hide();
  //bold subscription code Onload
   if($(".option-box").hasClass("subscribe")) {
        $(".bsub-widget__input").prop("checked", true);
        $("input[data-bsub-selling-plan-id-input]").val(boldAppPlanID);
    } else {
       $("input[data-bsub-purchase-option-one-time]").prop("checked", true);
       $("input[data-bsub-selling-plan-id-input]").val('');
    }
  $('.option-box').click(function(){
    //for update the price on ui after click variantion
    var change_pri = $(this).find('.product-price.money').text();
    var change_strike_pri = $(this).find('.strike_price').text();
    if($(this).find('.hidden_you_save')[0]){
      var save_html = $(this).find('.hidden_you_save').html();
    }else{
      var save_html = "";
    }
    var data_pouch = $(this).attr('data-pouch');
    if(data_pouch != ""){
      $('.pouch_count').text(data_pouch);
      $('.line_item_prop').val(data_pouch);
    }
    if(!$(this).hasClass('selected')){
      $('.price_from_inner').text(change_pri);
      $('#Quantity').val("1");
      $('#Quantity').text("1");
      if(change_strike_pri != ""){
        $('.var-strike-price').text(change_strike_pri);
      }else{
        $('.var-strike-price').text("");
      }
      if(save_html != ""){
        $('.pro_save_price_per').html(save_html);
      }
      else{
        $('.pro_save_price_per').html("");
      }
    }
    // for show free shipping text under add to cart after click variantion
    //     var change_pro_supp = $(this).find('.supply-time').text().toLowerCase();
    //     if(change_pro_supp.indexOf("free") > -1){
    //       $('.free_ship').removeClass("hide");
    //     }
    //     else{
    //       $('.free_ship').addClass("hide");
    //     }
    // for show subscibe in add to cart after click variantion
    var chng_add_cart_btn = $(this).find('.option-title h4').text().toLowerCase();
    if(chng_add_cart_btn.indexOf("subscribe") > -1){
      $('#AddToCartText').text("Add to Cart & Subscribe");
    }
    else{
      $('#AddToCartText').text("Add to Cart");
    }
    // for show save percentage after click variantion
    var chng_save_percentage = $(this).find('.supply-time').text().toLowerCase();
    if(chng_save_percentage.indexOf("save") > -1){
      var chng_final_save_text = chng_save_percentage.split('+')[0];
      if(chng_final_save_text.indexOf("day") > -1){
        var chng_final_update_save_text = chng_final_save_text.split('day')[1];
        $('.save_price').text(chng_final_update_save_text);
        $('.save_price').addClass('lable_enable');  
      }else{
        $('.save_price').text(chng_final_save_text); 
        $('.save_price').addClass('lable_enable');
      }
    }else{
      $('.save_price').text(" "); 
      $('.save_price').removeClass('lable_enable');
    }
    //bold subscription code by pratik
   
      if($(this).hasClass("subscribe")) {
          $(".bsub-widget__input").prop("checked", true);
          $("input[data-bsub-selling-plan-id-input]").val(boldAppPlanID);
      } else {
         $("input[data-bsub-purchase-option-one-time]").prop("checked", true);
         $("input[data-bsub-selling-plan-id-input]").val('');
      }
  
  });

  $('#Quantity').change(function(){
    if( $(this).val() == '' ||  $(this).val().trim() == '' ||  $(this).val().trim() == '0') {
      $(this).val(1);
    }
    var qty = $(this).val();
    
    var price = $('.option-box.selected .product-price.pp_inner').text().split('$')[1];
    var calculate_price = parseFloat(qty)*parseFloat(price);
    var updated_calculated_price = calculate_price.toFixed(2);
    $('.price_label.price_from_inner').text("$"+ updated_calculated_price);
    if($('.var-strike-price').text() != ""){
      var compare_pri = $('.option-box.selected .strike_price').text().split('$')[1];
      var calculate_compare_price = parseFloat(qty)*parseFloat(compare_pri);    
      var updated_calculated_compare_price = calculate_compare_price.toFixed(2);
      $('.var-strike-price').text("$"+ updated_calculated_compare_price);
    } 
    if($('.pro_save_price_per').text() != ""){
      var save_pri = $('.option-box.selected .save_money').text().split('$')[1];
      var calculate_save_price = parseFloat(qty)*parseFloat(save_pri);    
      var updated_calculated_save_price = calculate_save_price.toFixed(2);
      $('.saved_mon').text("$"+ updated_calculated_save_price);
    }  
  });
});

$(document).ready(function () {
  $(".product-wrap .product-description .doc_ico").click(function () {
    $(".product-wrap .product-description .doc_txt").slideToggle();
    $(this).toggleClass("active");
  });
});

function cart_price_available(){
  $.getJSON('/cart.js', function(cart) { 
    var curr_cart_pri = parseFloat(0.00);
    for (var i = 0; i < cart.items.length; i++){
      if(cart.items[i].product_type == 'affiliate'){
        //console.log(cart.items[i]);
        var cart_pro_pri = cart.items[i].final_line_price.toString();
        var resStr=cart_pro_pri.substring(0,cart_pro_pri.length-2)+"."+cart_pro_pri.substring(cart_pro_pri.length-2);
        curr_cart_pri = (parseFloat(curr_cart_pri) + parseFloat(resStr)).toFixed(2);    
      }
    }
    $('#cart-affiliate-total').text(curr_cart_pri);
  });
}

function total_bundle_price(){ 
  var selected_currency = $('#currency-select').val();
  var price_total = parseFloat(0.00);
  if (selected_currency == 'USD'){
    var mxm_val = parseFloat(110.00);
  }else{
    var mxm_val = parseFloat(145.00);
    $('.minimum-amount-currency').html('Minimum order of <span>$145</span> is required for your first order');
                                       $('.bundle_minimum span').html('Minimum order of <span>$145</span> is required for your first order');
                                                                      }
                                                                      var cart_money = parseFloat($('#cart-affiliate-total').text());
    $('.bundle_pro_lineitem').each(function(){
      var bundle_pro_price = $(this).find('.bundle_pro_price span').text();
      var line_item_price = bundle_pro_price.split('$')[1]; 
      price_total = parseFloat((parseFloat(price_total) + parseFloat(line_item_price)).toFixed(2));
    });
    $('.bundle_total').text('$'+price_total);
    if($('.prac_condition').hasClass('already_a_prac')){
      $('.bundle_shortof_price').addClass('hide'); 
      $('.bundle_minimum').addClass('hide');
      $('.bundle-cart-price').addClass('hide');
      if(price_total > 0){
        //$('.you-save-fourty').removeClass('hide'); 
        $('.bundle_total_price').addClass('red');
        $('.add-cart-bundle').removeClass('disable-btn');
        $('.add-cart-bundle').removeAttr("disabled");

      }else{
        //$('.you-save-fourty').addClass('hide'); 
        $('.bundle_total_price').removeClass('red');
        $('.add-cart-bundle').addClass('disable-btn');
        $('.add-cart-bundle').prop("disabled", true);
      }
    } 
    else if(cart_money > mxm_val){
      $('.bundle_shortof_price').addClass('hide'); 
      $('.bundle_minimum').addClass('hide'); 
      //$('.you-save-fourty').removeClass('hide'); 
      $('.bundle_total_price').addClass('red');
      $('.add-cart-bundle').removeClass('disable-btn');
      $('.add-cart-bundle').removeAttr("disabled"); 
      $('.bundle-cart-price').removeClass('hide');
      $('.bundle_cart').text('$'+cart_money);
    }
    else if(cart_money > 0 && cart_money <= mxm_val){
      var short_less_price = parseFloat((parseFloat(mxm_val) - parseFloat(cart_money)).toFixed(2));
      var bundle_total_plus_cart_money = parseFloat((parseFloat(cart_money) + parseFloat(price_total)).toFixed(2));
      var short_of_custom = parseFloat((parseFloat(mxm_val) - parseFloat(bundle_total_plus_cart_money)).toFixed(2));
      if(bundle_total_plus_cart_money > mxm_val){
        $('.bundle_shortof_price').addClass('hide'); 
        $('.bundle_minimum').addClass('hide'); 
        //$('.you-save-fourty').removeClass('hide'); 
        $('.bundle_total_price').addClass('red');
        $('.add-cart-bundle').removeClass('disable-btn');
        $('.add-cart-bundle').removeAttr("disabled");
        $('.bundle-cart-price').removeClass('hide');
        $('.bundle_cart').text('$'+cart_money);
      }
      else if(price_total >= short_less_price){   
        $('.bundle_shortof_price').addClass('hide'); 
        $('.bundle_minimum').addClass('hide'); 
        //$('.you-save-fourty').removeClass('hide'); 
        $('.bundle_total_price').addClass('red');
        $('.add-cart-bundle').removeClass('disable-btn');
        $('.add-cart-bundle').removeAttr("disabled");
        $('.bundle-cart-price').removeClass('hide');
        $('.bundle_cart').text('$'+cart_money);
      }
      else{
        $('.bundle_shortof_price').removeClass('hide'); 
        $('.bundle_minimum').removeClass('hide'); //new//
        $('.bundle_shortof').text('$'+ short_of_custom);
        $('.bundle-cart-price').removeClass('hide');
        $('.bundle_cart').text('$'+cart_money);
        //$('.you-save-fourty').addClass('hide'); 
        $('.bundle_total_price').removeClass('red');
        $('.add-cart-bundle').addClass('disable-btn');
        $('.add-cart-bundle').prop("disabled", true);  
      }
    }
    else{
      if(price_total < mxm_val){
        var less_price = (mxm_val - parseFloat(price_total)).toFixed(2);
        $('.bundle_shortof').text('$'+ less_price);
        $('.bundle_shortof_price').removeClass('hide'); 
        $('.bundle_minimum').removeClass('hide'); //new//
        $('.bundle_minimum').removeClass('hide'); 
        $('.bundle-cart-price').addClass('hide'); 
        //$('.you-save-fourty').addClass('hide'); 
        $('.bundle_total_price').removeClass('red');
        $('.add-cart-bundle').addClass('disable-btn');
        $('.add-cart-bundle').prop("disabled", true);
      }
      else{
        $('.bundle_shortof_price').addClass('hide'); 
        $('.bundle_minimum').addClass('hide'); 
        $('.bundle-cart-price').addClass('hide'); 
        //$('.you-save-fourty').removeClass('hide'); 
        $('.bundle_total_price').addClass('red');
        $('.add-cart-bundle').removeClass('disable-btn');
        $('.add-cart-bundle').removeAttr("disabled"); 
      }
    }
  }

  $(document).ready(function(){
    cart_price_available();
    setTimeout(function(){
      total_bundle_price();
    },1000);
    $('.lower-headbar input[type="checkbox"]').click(function(){
      var th_click = $(this);
      var item_selected = $(".selected_item").text();
      if(th_click.prop("checked") == true){

        var update_item_selected = parseInt(item_selected) + parseInt(1);
        $('.selected_item').text(update_item_selected);
        $('.selected_item2').text(update_item_selected);
        th_click.parent().parent().toggleClass('active');
        cart_price_available();
        var pro_name = th_click.attr('data-attr-name');
        var pro_price1 = th_click.attr('data-attr-price');
        var pro_price = $(pro_price1).text();
        pro_price= pro_price.replace("USD","");
        var pro_qty = th_click.parent().parent().find('.product_qty input').val();    
        var cal_price = ((pro_price.split('$')[1])*pro_qty).toFixed(2);
        var pro_data_id = th_click.attr('data-id');
        var pro_data_val = th_click.val();    
        var html = '<div class="bundle_pro_lineitem"><input type="hidden" data-id="'+ pro_data_id +'" data-qty="'+ pro_qty +'" data-price="'+ pro_price +'"/><div class="bundle_pro_name"><span>'+ pro_name +'</span></div><div class="bundle_pro_qty"><div class="qtyminus">−</div><span>'+ pro_qty +'</span><div class="qtyplus">+</div></div><div class="bundle_pro_price"><span>$'+ cal_price +'</span></div></div>'
        $('.bunlde_product_inner').append(html);     
        total_bundle_price();
        var bundle_lenght = $('.bunlde_product_inner .bundle_pro_lineitem').length;
        console.log(bundle_lenght);
        if(bundle_lenght == 1){
          $('.bundle_prod_wrap').addClass('show with_animate');
          setTimeout(function(){
            $('.bundle_prod_wrap').removeClass('show with_animate');
          },1000);
        }
      }
      else if(th_click.prop("checked") == false){
        cart_price_available();
        var update_item_selected = parseInt(item_selected) - parseInt(1);
        $('.selected_item').text(update_item_selected);
        $('.selected_item2').text(update_item_selected);
        th_click.parent().parent().toggleClass('active');
        var pro_data_id = th_click.attr('data-id');
        $('.bundle_pro_lineitem').each(function(){
          var current_pro_data_id =$(this).find('input').attr('data-id');
          if(current_pro_data_id == pro_data_id){
            $(this).remove();
            return false; 
          }  
        });
        total_bundle_price();
      }
    });
    $('.product_qty input').change(function(){
      cart_price_available();
      var this_input_val = $(this).val();
      var one = String(this_input_val).charAt(0);
      // convert the first digit back to an integer
      var one_as_number = Number(one); 
      if(one_as_number == 0){
        $(this).val(1);
      }
      var qty_related_checkbox = $(this).parent().parent().parent().find('.select_option input[type="checkbox"]');    
      if(qty_related_checkbox.prop("checked") == true){
        var updated_qty = $(this).val();
        var pro_price1 = qty_related_checkbox.attr('data-attr-price');
        var cal_price = ((pro_price1.split('$')[1])*updated_qty).toFixed(2);
        var qty_update_for = qty_related_checkbox.attr('data-id');
        var current_product = $('.bundle_pro_lineitem input[data-id = "'+ qty_update_for +'"]');
        current_product.attr('data-qty',updated_qty);
        current_product.parent().find('.bundle_pro_qty span').text(updated_qty);
        current_product.parent().find('.bundle_pro_price span').text('$'+cal_price);  
        setTimeout(function(){
          total_bundle_price();
        },1000);
      }
    });

     $(document).on("click",".qtyminus",function() {
        var curqty = $(this).parents('.bundle_pro_lineitem').find('input').attr("data-qty");
       console.log(curqty);
       if(curqty == 1){
         return false;
       }
       curqty--;
       $(this).next('span').text(curqty);
        $(this).parents('.bundle_pro_lineitem').find('input').attr("data-qty" , curqty);
        var pro_price1 = $(this).parents('.bundle_pro_lineitem').find('input').attr('data-price');
        var cal_price = ((pro_price1.split('$')[1])*curqty).toFixed(2);
        $(this).parents('.bundle_pro_lineitem').find('.bundle_pro_price span').text('$'+cal_price);  
        setTimeout(function(){
          total_bundle_price();
        },500);
      });
    $(document).on("click",".qtyplus",function() {
        var curqty = $(this).parents('.bundle_pro_lineitem').find('input').attr("data-qty");
       console.log(curqty);
         curqty++;
       $(this).prev('span').text(curqty);
       $(this).parents('.bundle_pro_lineitem').find('input').attr("data-qty" , curqty);
        var pro_price1 = $(this).parents('.bundle_pro_lineitem').find('input').attr('data-price');
        var cal_price = ((pro_price1.split('$')[1])*curqty).toFixed(2);
        $(this).parents('.bundle_pro_lineitem').find('.bundle_pro_price span').text('$'+cal_price);  
        setTimeout(function(){
          total_bundle_price();
        },500);
      });
    $('.more-desc').click(function(){
      $(this).parent().toggleClass('active'); 
      $(this).parent().find('.desc').toggleClass('hide');
    });
    $('.product_qty input').on('keypress', function(e) {
      $(this).prop("maxlength", 3);
      e = (e) ? e : window.event;
      var charCode = (e.which) ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
    });
    $('.product_qty input').on('cut copy paste',function(e) {
      e.preventDefault();
    });
    


    // Practitioner Inventory Slider for mobile design

    // if ($(window).width() < 1025) {
    //   var $status = $('.current_slide');
    //   var $slickElement = $('.mob_prac_slider_cont');

    //   $slickElement.slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     rows: 0,
    //     dots: false,
    //     arrows: true
    //   });

    //   $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //     //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    //     var i = (currentSlide ? currentSlide : 0) + 1;
    //     $status.text(i + '/' + slick.slideCount);
    //   });
    // }

    $('.mob.items_func').click(function() {
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $('.bundle_prod_wrap').removeClass('show');
      }else{
        $(this).addClass('active');
        $('.bundle_prod_wrap').addClass('show');
      }
    });

    $('.bundle_prod_wrap .bundle_prod_close_btn').click(function() {
      $('.mob.items_func').removeClass('active');
      $('.bundle_prod_wrap').removeClass('show');
    });

  });

  /*========MDL-AUG-3011 Landing Page Campaigns===========*/
  $('.additional__add-to-cart .addtocart').click(function(){
    $('#AddToCart').trigger('click');
  });

  
   

  $(document).ready(function(){
    $('.customer__testimonials-slider.owl-carousel').owlCarousel({
      dots:true,
      //items:1,
      nav:true,
      //loop: true,
      autoplay:true,
      autoplayTimeout:3000,
      autoplayHoverPause:true,
      navText: ["<i class='icon-arrow-prev prev-arrow slick-arrow'></i>", "<i class='icon-arrow-next next-arrow slick-arrow'></i>"],
      responsive: {
        0: {
          items: 1,
          nav: true
        },
        667: {
          items: 1
        },
        960: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });
  });

  $(document).ready(function () {
    $('.customer__testimonials.sliding .customer__testimonials-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      fade: true,
      dots: true,
      arrows: true,
      adaptiveHeight: true
    });
  });

  $('#currency-select').selectize({
    create: true,
    sortField: {
      field: 'none',
      direction: 'asc'
    },
    dropdownParent: '.currency-wrap'
  });

  $(document).ready(function(){
    var selected_currency = $('#currency-select').val();
    if(selected_currency == 'CAD'){    
      //     $('.faq-pricing').text('$145');
      //     $('.announcement_text_converted').text('Free CA Shipping Available');
      //     $('.shipping_converted').text('Shipping to Canada is FREE for orders over $85 CAD');
      //     $('.top_bar.CAD,.product_freeship.CAD').show();
      //     $('.top_bar.USD,.product_freeship.USD').hide();
      $('.top_bar.CAD,.product_freeship.CAD').hide();
      $('.top_bar.USD,.product_freeship.USD').show();
    }else{
      $('.top_bar.CAD,.product_freeship.CAD').hide();
      $('.top_bar.USD,.product_freeship.USD').show();

    }
  });

  /* -- MDL-May-3045 Site Speed Issue -- */

  document.addEventListener("DOMContentLoaded", function () {
    window.active = false;

    const lazyLoad = function () {
      if (active === false) {
         window.active = true;
        let lazyImages = [].slice.call(document.querySelectorAll("img.lazyload"));

        setTimeout(function () {
          lazyImages.forEach(function (lazyImage) {
            if ((lazyImage.getBoundingClientRect().top <= window.innerHeight || lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
              lazyImage.src = lazyImage.dataset.src;
              // lazyImage.srcset = lazyImage.dataset.srcset;
              lazyImage.classList.remove("lazy");

              lazyImages = lazyImages.filter(function (image) {
                return image !== lazyImage;
              });

              if (lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
                window.removeEventListener("load", lazyLoad);
              }
            }
          });

          active = false;
        }, 100);
      }
    };
    window.lazyLoadGlobal = lazyLoad;
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
    window.addEventListener("load", lazyLoad);
  });


  /* -- MDL-JUL-3052 Homepage Updates -- */

  $(document).ready(function () {
    $('.home-slider .hero-content').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      adaptiveHeight: true
    });

    $('body').on('change', '.add_to_cart_form .product-single__variants', function() {

      var select_val = $(this).val();
      var parent_grid = $(this).parents(".coll_pro_grid");
      var add_cart_prop = parent_grid.find(".collection_price.val_"+select_val+" .add_cart_prop").text();
      parent_grid.find('.line_item_prop').val(add_cart_prop);
      parent_grid.find(".collection_price.val_"+select_val).removeClass("hide");
      parent_grid.find(".collection_price.val_"+select_val).siblings().addClass("hide");
      if(parent_grid.find(".collection_price.val_"+select_val).hasClass("subscription_product")){
        parent_grid.find('.addtocart .AddToCartText').text("Subscribe");
        let sellingGroupId = parent_grid.find('div[data-bsub-selling-plan-group-id]').attr("data-bsub-selling-plan-group-id");
        let sellingPlanId = parent_grid.find('div[data-bsub-selling-plan-id]').attr("data-bsub-selling-plan-id");
        parent_grid.find('.add_to_cart_form').prepend(
          '<input type="hidden" class="subscription_hidden" name="bsub-selling-plan-group" value="'+sellingGroupId+'" /><input type="hidden" class="subscription_hidden" name="bsub-selling-plan-'+sellingGroupId+'" value="'+sellingPlanId+'" /><input type="hidden" class="subscription_hidden" name="selling_plan" value="'+sellingPlanId+'" />'
        ); 
      }else{
        parent_grid.find('.subscription_hidden').remove();
        parent_grid.find('.addtocart .AddToCartText').text("Add to cart");
      }
      
    });

    if($(window).width() < 960) {
      var $status = $('.current_col_slide');
      var $slickElement = $('.collection-grid-slider');
      $slickElement.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        fade: true,
        adaptiveHeight: true
      });
      $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $status.text(i + ' of ' + slick.slideCount);
      });
    }

    $('.collection-home-grid-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      adaptiveHeight: false,
      infinite: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }        
      ]
    });

    $('.home-sec-testimonials ul').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      infinite: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }        
      ]
    });

    $('.pills-testimonials-slider ul').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      infinite: false,
      swipeToSlide: true
    });

    $(".pills_products_section .learn_more_pop > a").click(function() {
      $(".learn_more_pop").removeClass("active");
      $(this).parent(".learn_more_pop").addClass("active");
    });
    $(".pills-lighthouse .pills-landing-close").click(function() {
      $(".learn_more_pop").removeClass("active");
    });

    $(".home-sec-hotspot .image_spot .icon img").click(function(e) {
      e.stopPropagation();
      if($(this).parents(".image_spot").hasClass('open')) {
        $(this).parents(".image_spot").removeClass("open");
      } else {
        $(this).parents(".image_spot").siblings().removeClass("open");
        $(this).parents(".image_spot").addClass("open");
      }
    });
    $(document).click(function () {
      var $hs = $(".image_spot");
      if ($hs.hasClass('open')) {
        $hs.removeClass('open');
      }
    });

//     $('.CartDrawer--overlay').click(function(event) {
//       jQuery('body, html').removeClass('js-drawer-open-right js-drawer-open'); 
//     });

  });

  $(document).ready(function(){
    $('.pills-product-single__variants').change(function() {
      var select_val = $(this).val();
      var select_pouch = $("option:selected", this).attr('data-pouch'); 
      //var select_pouch = $(this).attr('data-pouch');
      var select_price = $("option:selected", this).attr('data-price');
      //var select_price = $(this).attr('data-price');
      var parent_grid = $(this).parents(".pills_grid");
      parent_grid.find('.pouch_details .var_desc[data-attr*='+ select_val +']').addClass('show');
      parent_grid.find('.pouch_details .var_desc[data-attr*='+ select_val +']').siblings().removeClass('show');
      parent_grid.find('.below_button_bar .below_details_data[data-attr*='+ select_val +']').addClass('show');
      parent_grid.find('.below_button_bar .below_details_data[data-attr*='+ select_val +']').siblings().removeClass('show');
      parent_grid.find('.line_item_prop').val(select_pouch);
      parent_grid.find('.addtocart .price').text(select_price);
    });
  });

  $(document).ready(function() {
    $(".pills-bundle-btn a[href^='#']").click(function (e) {
      e.preventDefault();

      if ($(window).width() > 959) {
        if ($(".custom_header").hasClass("sticky_header_nav")) {
          var post = $($(this).attr("href")).offset().top - 130;
        } else {
          var post = $($(this).attr("href")).offset().top - 270;
        }
      } else {
        if ($(".custom_header").hasClass("sticky_header_nav")) {
          var post = $($(this).attr("href")).offset().top - 90;
        } else {
          var post = $($(this).attr("href")).offset().top - 180;
        }
      }

      jQuery("body, html").animate({
        scrollTop: post
      }, 500);
    });
    
    var id = $(".option-box.subscribe").find(".product-info").data("productid");
    $('#productSelect option[value="'+ id +'"]').prop('selected', true);

    $('.single_select_option').click(function(){
     if($(this).parents(".product_name").hasClass("active")) {
       $(this).parents(".select_option").find(".select_checkbox_design").text("REMOVE");
     } else {
       $(this).parents(".select_option").find(".select_checkbox_design").text("ADD");
     }
    });

    $('.category-type .title-text').on('click', function() {
      $(this).toggleClass("rotate");
      $(".category-wrapper").toggleClass("active");
    });
    var practitionerDefaultHTML = $(".mob_prac_slider_cont").html();
     $('.facet-checkbox').click(function(){
       var selectedTags = [];
       $(".category-list .item").each(function() {
         if($(this).find("input").is(":checked")) {
            var checkboxvalue = $(this).find("input").val();
            selectedTags.push(checkboxvalue);
         }
       });
       if(selectedTags.includes("all")) {
          $(".lower-headbar").show();
       } else {
        $(".lower-headbar").hide();
        for(var i=0; i< selectedTags.length; i++) {
           $(".lower-headbar").each(function() {
              var tags = $(this).data("tag");
              if(tags.indexOf(selectedTags[i]) != -1){
                $(this).show();
              }
           });
         }
       }
    });

     $('.search_blog_inner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      adaptiveHeight: false,
      infinite: false,
      swipeToSlide: true,
       responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 660,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }        
      ]
    });
    
    $(".dropdown-item.active").next(".sub-menu").addClass("open");
    $('.category_title').on('click', function(){
      $(".category").removeClass("active");
      $(this).parents(".category").addClass("active");
     $(".sub-menu").removeClass("open");
    
    });


    // if($("input[name=bsub-selling-plan-group]:checked").val() != 'once') {
    //     $('.bsub-widget__input').trigger('click');
    //     $('.bsub-widget__plans-container').removeClass("bsub__hidden");
    // }else{
    //     $('.rc_widget__option__input--subsave').trigger('click');
    //     $('.bsub-widget__plans-container').addClass("bsub__hidden");
    // }

    
    if($('.option-box.subscribe').hasClass("selected")) {
        $('.bsub-widget__input').trigger('click');
        $('.bsub-widget__plans-container').removeClass("bsub__hidden");
      }else{
        $('input[value=once]').trigger('click');
        $('.bsub-widget__plans-container').addClass("bsub__hidden");
      }
    $(document).on("click",".option-box",function() {
    if($('.option-box.subscribe').hasClass("selected")) {
        $('.bsub-widget__input').trigger('click');
        $('.bsub-widget__plans-container').removeClass("bsub__hidden");
      }else{
        $('input[value=once]').trigger('click');
        $('.bsub-widget__plans-container').addClass("bsub__hidden");
      }
  });
  

    
   
  });


function addWelcomeKit() {
   var welcomeKitAlreadyInCart = false;
     $.ajax({
       type: 'GET',
       url: '/cart.json',
       dataType: 'jsonp',
       success: function(data) {
         var items = data['items'];
        for (var i = 0; i < items.length; i++) {
            if (items[i]["id"] == "48259025895724") {
                welcomeKitAlreadyInCart = true;
                break;
            }
        }
       }
   });
    var qty = "1";  
    var variantID = "48259025895724";  
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var parsedState = JSON.parse(xhr.responseText);
         $.get('/cart.js', function(data){
              $("#CartCount").html(data.item_count);
            }, "json")
        ajaxCart.load();
      }
    };
    var data = JSON.stringify({"quantity": qty, "id": variantID });
    xhr.send(data);
  }

      
var unlockOfferbtn = document.querySelectorAll(".unlock_offer");
var variantID = 48280263360812;
var offerProID = 48259025895724;
unlockOfferbtn.forEach((btn) => {
    btn.addEventListener('click', (event) => {
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
          var parsedState = JSON.parse(xhr.responseText);
          $.get('/cart.js', function(data){
            $("#CartCount").html(data.item_count);
          }, "json");
          ajaxCart.load();
           var welcomeKitAlreadyInCart = false;
           $.ajax({
             type: 'GET',
             url: '/cart.json',
             dataType: 'jsonp',
             success: function(data) {
              var items = data['items'];
              for (var i = 0; i < items.length; i++) {
                if (items[i]["id"] == offerProID) {
                  welcomeKitAlreadyInCart = true;
                  break;
                }
              }
                if (welcomeKitAlreadyInCart == false) {
                  addWelcomeKit();
                  timber.RightDrawer.open();
                } else {
                    timber.RightDrawer.open();
                }
             }
           });
      }
    };
    var data = JSON.stringify({"quantity": 1, "id": variantID});
    xhr.send(data);
    });
}); 


